import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchStaffApi,
  addStaffApi,
  updateStaffApi,
  deleteStaffApi,
} from "../services/StaffService";

// Fetch all staff
export const fetchStaff = createAsyncThunk(
  "staff/fetchStaff",
  async (searchText = "") => {
    const response = await fetchStaffApi(searchText);
    return response;
  }
);

// Add new staff
export const addStaff = createAsyncThunk(
  "staff/addStaff",
  async (staffData) => {
    const response = await addStaffApi(staffData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Update staff
export const updateStaff = createAsyncThunk(
  "staff/updateStaff",
  async (staffData) => {
    const response = await updateStaffApi(staffData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Delete staff
export const deleteStaff = createAsyncThunk(
  "staff/deleteStaff",
  async ({ staffId, currentUserId }) => {
    const response = await deleteStaffApi(staffId, currentUserId);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

const staffSlice = createSlice({
  name: "staff",
  initialState: {
    staff: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaff.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchStaff.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.staff = action.payload;
      })
      .addCase(fetchStaff.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addStaff.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addStaff.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addStaff.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateStaff.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateStaff.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateStaff.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteStaff.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteStaff.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deleteStaff.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default staffSlice.reducer;
